"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeDebugLanguages = void 0;
var i18next_formatters_1 = require("@equiem/i18next-formatters");
var mapValues_1 = __importDefault(require("lodash/mapValues"));
function isResourceKeyLoader(loaderOrResources) {
    return typeof loaderOrResources === "function";
}
function isResourcePromise(resourcesOrPromise) {
    return typeof resourcesOrPromise.then === "function";
}
function toDebugLanguage(source, padLength) {
    return typeof source === "string"
        ? (0, i18next_formatters_1.pseudolocalise)(source, padLength)
        : (0, mapValues_1.default)(source, function (child) { return toDebugLanguage(child, padLength); });
}
function toDebugLoader(loader, padLength) {
    // Back-end services can't use asynchronous resource loaders, so if `loader`
    // is synchronous, we MUST return a synchronous loader. In practice, this
    // function returns exactly the same type as the input.
    if (!isResourceKeyLoader(loader)) {
        // `loader` is a static language object
        return toDebugLanguage(loader, padLength);
    }
    // `loader` is a loader function
    // eslint-disable-next-line @typescript-eslint/promise-function-async
    return function () {
        var maybePromiseLanguage = loader();
        if (!isResourcePromise(maybePromiseLanguage)) {
            // `loader` is synchronous
            return toDebugLanguage(maybePromiseLanguage, padLength);
        }
        // `loader` is asynchronous
        return maybePromiseLanguage.then(function (language) { return toDebugLanguage(language, padLength); });
    };
}
function makeDebugLanguages(languages, defaultLocale) {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    var baseLanguage = (_a = languages[defaultLocale]) !== null && _a !== void 0 ? _a : {};
    return {
        "en-US-debug": (0, mapValues_1.default)(baseLanguage, function (loader) { return toDebugLoader(loader, false); }),
        "en-US-debug-longer": (0, mapValues_1.default)(baseLanguage, function (loader) { return toDebugLoader(loader, true); }),
    };
}
exports.makeDebugLanguages = makeDebugLanguages;
